import { ActionReducerMap } from '@ngrx/store';

import { RateTypeState, rateTypeFeatureKey, rateTypeReducer } from './rate-type/rate-type.reducer';
import { ProgramState, programFeatureKey, programReducer } from './program/program.reducer';
import { LocationState, locationFeatureKey, locationReducer } from './location/location.reducer';

import {
  InstitutionsState,
  institutionsFeatureKey,
  institutionsReducer
} from './institutions/institutions.reducer';
import { CompareState, compareFeatureKey, compareReducer } from './compare/compare.reducer';
import { SavedState, savedFeatureKey, savedReducer } from './saved/saved.reducer';

export interface RootState {
  [programFeatureKey]: ProgramState;
  [rateTypeFeatureKey]: RateTypeState;
  [locationFeatureKey]: LocationState;
  [institutionsFeatureKey]: InstitutionsState;
  [compareFeatureKey]: CompareState;
  [savedFeatureKey]: SavedState;
}

export const reducers: ActionReducerMap<RootState> = {
  [programFeatureKey]: programReducer,
  [rateTypeFeatureKey]: rateTypeReducer,
  [locationFeatureKey]: locationReducer,
  [institutionsFeatureKey]: institutionsReducer,
  [compareFeatureKey]: compareReducer,
  [savedFeatureKey]: savedReducer
};
